export var AutopilotResponseCode;
(function (AutopilotResponseCode) {
    AutopilotResponseCode[AutopilotResponseCode["OK"] = 0] = "OK";
    AutopilotResponseCode[AutopilotResponseCode["OK_FALLBACK"] = 1] = "OK_FALLBACK";
})(AutopilotResponseCode || (AutopilotResponseCode = {}));
